import { Globe, Store } from 'lucide-react';
import type { PresenceGlyph as PresenceGlyphId } from '../../../lib/presence';
import { SocialLogo } from '../ui';

// A presence's mark (`linkProviderGlyph` in lib/presence.ts): the brand marks come from the generated `SocialLogo`
// (native-apps/scripts/generate-social-logos.mjs, the same table as both phones), Shopify has no vendored mark and
// draws the store glyph, and the globe is the fallback for websites and anything new.
const NETWORKS: Partial<Record<PresenceGlyphId, string>> = {
  facebook: 'FACEBOOK',
  instagram: 'INSTAGRAM',
  x: 'X',
  youtube: 'YOUTUBE',
  tiktok: 'TIKTOK',
  linkedin: 'LINKEDIN',
  pinterest: 'PINTEREST',
  threads: 'THREADS',
  google: 'GOOGLE_BUSINESS',
  yelp: 'YELP',
  etsy: 'ETSY',
};

export function PresenceGlyph({ glyph, size = 16 }: { glyph: PresenceGlyphId; size?: number }) {
  if (glyph === 'shopify') return <Store size={size} aria-hidden />;
  const network = NETWORKS[glyph];
  return network ? <SocialLogo network={network} size={size} /> : <Globe size={size} aria-hidden />;
}
